import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';

import { TooltipSide } from './tooltip-positions';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'ideals-tooltip',
    '[class]': 'sideClass()',
    '[class.ideals-tooltip--width-auto]': 'widthAuto()',
  },
  selector: 'ideals-tooltip',
  styleUrl: './tooltip.component.scss',
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  readonly content = input('');
  readonly html = input(false);
  readonly side = input<TooltipSide>('bottom');
  readonly widthAuto = input(false);

  protected readonly sideClass = computed(() => `ideals-tooltip--${this.side()}`);
}
